import {
	DealType,
	IncentiveObject,
	PaymentTermsResponse,
	WriteupResponse,
	RebateResponse,
	IncentiveRequest,
	TradeInResponse,
	FiResponse,
	TermListObject,
	AllCoveragesObject,
	ScheduleTestDriveData,
	DatesAppointmentData,
	TimeslotsAppointmentData,
	AppointmentResponseData, PaymentTermsDetails,
	AccessoryResponse,
	TestDriveAppointmentData,
	TaxesAndFees,
	ShiftDigitalData, GtmData, TealiumResponse,
} from '@/types/writeup';
import {
	TradeInServiceTypeAheadResponse,
	TradeInServiceVinResponse,
	TradeInServiceDetailsResponse,
	TradeInCustomerVehicleInputs,
} from '@/types/tradepending';


export class WriteupState {
	writeupObject: WriteupResponse | null = null

	termsObject: PaymentTermsResponse | null = null

	incentives: IncentiveObject[] | null = null

	pendingDealType: DealType | null = null

	isError = false

	isWriteupUpdating = false

	isIncentivesSaving = false

	isTermsLoading = false

	isTermsUpdating: string[] = []

	isDealTypeUpdating = false

	tradeInObject: TradeInResponse | null = null

	isTradeInUpdating = false

	fiObjects: Array <FiResponse> = []

	isFiObjectUpdating = false

	allCoverages: Array <AllCoveragesObject> = []

	termList: Array <TermListObject> = []

	options: Array<Array <FiResponse>> = []

	isRebatesUpdating = false

	isRebatesSettingsApplied = true

	rebates: RebateResponse[] = []

	vehicleList: TradeInServiceTypeAheadResponse[] = []

	isVehiclesFetching = false;

	isVehicleSuggestionUpdating = false;

	vehicleDetails: TradeInServiceDetailsResponse | null = null

	isVehiclesDetailsFetching = false;

	isVehicleSuggestionError = false;

	lastIncentiveRequest: IncentiveRequest | null = null

	scheduleTestDriveData: ScheduleTestDriveData | null = null

	datesAppointment: DatesAppointmentData | null = null

	timeslotsAppointment: TimeslotsAppointmentData | null = null

	testDriveAppointmentData: TestDriveAppointmentData | null = null

	tradeInEnterVehicleInputs: TradeInCustomerVehicleInputs= {
		vin: '',
		state: '',
		plate: '',
		make: '',
		model: '',
		trim: '',
		year: '',
		formType: '',
	}

	tradeInReport: any;

	isTradeInReportUpdating = false;

	taxesAndFees: TaxesAndFees | null = null;

	optionProvider = '';

	appointmentResponseData: AppointmentResponseData | null = null

	isDatesAppointmentUpdating = false

	isTimeslotsAppointmentUpdating = true

	paymentTermsDetails: Partial<PaymentTermsDetails> = {}

	isAccessoryUpdating = false;

	accessories: Array <AccessoryResponse> = [];

	shiftDigitalData: Partial<ShiftDigitalData> | null = null

	gtmData: Partial<GtmData> | null = null

	tealiumData: Partial<TealiumResponse> | null = null;

	isPpLoaded = false;

	isLoading = false;

	isBusy = false;
}
